import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { postData } from '../Services/api';
import { toast } from 'react-toastify';
import JoditEditor from 'jodit-react';

const AddFAQs = () => {
    const editor = useRef(null);
    const [values, setValues] = useState({
        question: "",
        answer: "",
    })
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }

    const validateFAQs = () => {
        const { question, answer, } = values;

        if (!question.trim()) {
            toast.dismiss();
            toast.error("question is required.");
            return false;
        }
        if (!answer.trim()) {
            toast.dismiss();
            toast.error("Answer is required.");
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateFAQs()) return;
        setLoading(true)
        try {
            const res = await postData('/faqs/add', values);
            if (res.status) {
                toast.success(res.message)
                navigate('/faqs/faq-list');
                setValues({
                    question: "",
                    content: "",
                })
            }
        } catch (error) {
            console.log("error faq adding", error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/faqs/faq-list">FAQs</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Add FAQs
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-question">
                                        <h2 className="mb-0">Add FAQs</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add FAQs</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Question</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter question"
                                                        name='question'
                                                        value={values.question}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Answer</label>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={values.answer}
                                                        onChange={(newContent) =>
                                                            setValues(prev => ({
                                                                ...prev,
                                                                answer: newContent
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/faqs/faq-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddFAQs